/* eslint-disable react/no-unescaped-entities */
import { memo } from 'react'
import { Typography } from '@material-ui/core'
import { TEAL_BEST_OFFER_TEST } from 'OptimizelyProvider'
import {
  OptimizelyExperiment,
  OptimizelyVariation
} from '@optimizely/react-sdk'

const ContactTitle = () => {
  return (
    <OptimizelyExperiment experiment={TEAL_BEST_OFFER_TEST} timeout={3000}>
      <OptimizelyVariation variation="variation_3">
        <Typography variant="h4">
          Jetzt einen verlässlichen Kreditüberblick von über 300 Banken bekommen
        </Typography>
      </OptimizelyVariation>
      <OptimizelyVariation default>
        <Typography variant="h4">
          Jetzt einen verlässlichen Kreditüberblick von über 20 Banken bekommen
        </Typography>
      </OptimizelyVariation>
    </OptimizelyExperiment>
  )
}

export default memo(ContactTitle)
